import { render, staticRenderFns } from "./DvHome.vue?vue&type=template&id=d3fdff40&scoped=true&"
import script from "./DvHome.vue?vue&type=script&lang=js&"
export * from "./DvHome.vue?vue&type=script&lang=js&"
import style0 from "./DvHome.vue?vue&type=style&index=0&id=d3fdff40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3fdff40",
  null
  
)

export default component.exports